/* Pialú · Club — recalcul de « Ganas N puntos » au changement de variante (lot C, 09.2026).
   Même mécanique que assets/installments-mp.js : un MutationObserver sur le prix [data-price] de la
   fiche ; à chaque changement, le texte du bloc [data-pialu-club-pts] est recomposé depuis data-tpl
   et data-rate. Idempotent, sous try/catch, ne touche à rien d'autre. */
(function () {
  'use strict';
  if (window.__pialuClubBound) return;
  window.__pialuClubBound = true;

  function parsePriceCents(text) {
    if (!text) return null;
    var stripped = String(text).replace(/[^0-9.,-]/g, '');
    if (!stripped) return null;
    var lastComma = stripped.lastIndexOf(','), lastDot = stripped.lastIndexOf('.');
    var normalized = lastComma > lastDot ? stripped.replace(/\./g, '').replace(',', '.') : stripped.replace(/,/g, '');
    var n = parseFloat(normalized);
    return isNaN(n) ? null : Math.round(n * 100);
  }
  function fmt(n) { return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }

  function update(cents) {
    var els = document.querySelectorAll('[data-pialu-club-pts][data-context="pdp"]');
    for (var i = 0; i < els.length; i++) {
      try {
        var el = els[i], rate = parseFloat(el.getAttribute('data-rate')) || 1, tpl = el.getAttribute('data-tpl') || '';
        var pts = Math.floor(cents * rate / 100);
        var t = el.querySelector('[data-pialu-club-pts-text]');
        if (t && tpl) t.textContent = tpl.replace('[pts]', fmt(pts));
        el.style.display = cents > 0 ? '' : 'none';
      } catch (e) { }
    }
  }

  function bind() {
    try {
      var block = document.querySelector('[data-pialu-club-pts][data-context="pdp"]');
      if (!block) return;
      var scope = block.closest('[data-section-type="product"]') || block.closest('.product') || document;
      var priceEls = scope.querySelectorAll('.product__price [data-price], [data-price]');
      for (var i = 0; i < priceEls.length; i++) {
        var p = priceEls[i];
        if (p.__pialuClubObs || p.closest('.sticky-atc-bar, .product-card, .recommended-products, .cross-sells')) continue;
        p.__pialuClubObs = true;
        (function (el) {
          new MutationObserver(function () {
            var c = parsePriceCents(el.textContent);
            if (c != null) update(c);
          }).observe(el, { childList: true, characterData: true, subtree: true });
        })(p);
      }
    } catch (e) { }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind); else bind();
  document.addEventListener('shopify:section:load', bind);
})();
